'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { RecordAutoRefresh } from './RecordAutoRefresh';
import { AutoRefreshOnNewVersionContainer } from './AutoRefreshOnNewVersionContainer';

/**
 * Carries its own `QueryClient` so it mounts in any root layout, even one
 * without a provider (the customer app's).
 *
 * `recordReload` is a plain function, not a hook, because the reload awaits it.
 *
 * The public sites pass a longer `pollIntervalMs`: a visitor's tab is worth
 * fewer invocations than a worker's.
 */
export const AutoRefreshOnNewVersion = ({
  recordReload,
  pollIntervalMs,
}: {
  recordReload?: RecordAutoRefresh;
  pollIntervalMs?: number;
}) => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: { queries: { retry: false } },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <AutoRefreshOnNewVersionContainer
        recordReload={recordReload}
        pollIntervalMs={pollIntervalMs}
      />
    </QueryClientProvider>
  );
};
